/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './external/external_system';
import '../common/currency';
import './octopus';
import './stored_value_balance';
import './rewards';
import '../common/currency_codes';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "TransactionState": {
            "values": {
              "PENDING": 1,
              "SETTLED": 2,
              "VOIDED": 3,
              "DECLINED": 4,
              "REFUNDED": 5,
              "REVERSED": 6,
              "DISPUTED": 7,
              "DISPUTE_REVERSED": 8,
              "DISPUTE_WON": 9,
              "IN_REVIEW": 10,
              "IN_REVERSAL": 11,
              "WAITING_ON_EXTERNAL": 12,
              "SETTLED_EXTERNALLY": 13,
              "REVERSED_EXTERNALLY": 14,
              "IN_REVERSAL_EXTERNALLY": 15,
              "DISPUTE_WRITTEN_OFF": 16
            }
          },
          "TransactionReasonCode": {
            "values": {
              "ATM_WITHDRAWAL": 1,
              "ATM_CHECK_DEPOSIT": 2,
              "ATM_FEE": 3,
              "CARD_PRESENT_PURCHASE": 4,
              "CARD_NOT_PRESENT_PURCHASE": 5,
              "ACCOUNT_MAINTENANCE_FEE": 6,
              "BALANCE_ADJUSTMENT": 7,
              "SQUARE_CASH_SELF": 8,
              "SQUARE_CASH_P2P": 9,
              "SQUARE_CASH_BUSINESS": 10,
              "PINDEBIT": 11,
              "PINCREDIT": 12,
              "ACH": 13,
              "UNLINKED_CREDIT": 14,
              "GREENDOT_FEE": 15,
              "NETWORK_FEE": 16,
              "SQUARE_CASH_FEE": 17,
              "CARD_MERCHANT_REFUND": 18,
              "OVERDRAFT_FEE": 19,
              "CARD_PRE_AUTHORIZATION": 20,
              "MOBILE_CHECK_DEPOSIT": 21,
              "CHECK_PAYMENT": 22,
              "CARD_VALIDATION": 23,
              "ONLINE_PURCHASE": 24,
              "ATM_BALANCE_CHECK": 25,
              "SQUARE_REGISTER_INSTANT_DEPOSIT": 26,
              "SQUARE_CASH_REFERRAL": 27,
              "APPLE_PAY_PURCHASE": 28,
              "APPLE_PAY_ACTIVATION": 29,
              "INTERNAL_CURRENCY_EXCHANGE": 30,
              "BITCOIN_TRANSFER": 31,
              "ANDROID_PAY_PURCHASE": 32,
              "ANDROID_PAY_ACTIVATION": 33,
              "PINDEBIT_CASHBACK": 34,
              "PINDEBIT_QUASI_CASH": 35,
              "CARD_ACTIVATION": 36,
              "FUNDS_TRANSFER": 37,
              "BILL_PAYMENT": 38,
              "ATM_UNVERIFIED_DEPOSIT": 39,
              "ATM_CASH_DEPOSIT": 40,
              "SAMSUNG_PAY_PURCHASE": 41,
              "SAMSUNG_PAY_ACTIVATION": 42,
              "MICROSOFT_PAY_PURCHASE": 43,
              "MICROSOFT_PAY_ACTIVATION": 44,
              "VISA_CHECKOUT_PURCHASE": 45,
              "VISA_CHECKOUT_ACTIVATION": 46,
              "FACEBOOK_TOKEN_PURCHASE": 47,
              "FACEBOOK_TOKEN_ACTIVATION": 48,
              "NETFLIX_TOKEN_PURCHASE": 49,
              "NETFLIX_TOKEN_ACTIVATION": 50,
              "ATM_TRANSFER": 51,
              "BITCOIN_TRADE_SETTLEMENT": 52,
              "CAVIAR_SETTLEMENT": 53,
              "DIGITAL_WALLET_PURCHASE": 54,
              "SECURITIES_TRADE": 55,
              "SECURITIES_DIVIDEND_PAYMENT": 56,
              "SECURITIES_CORPORATE_ACTION": 57,
              "ACCOUNT_FUNDING_TRANSACTION": 58,
              "ORIGINAL_CREDIT_TRANSACTION": 59,
              "CUSTOMER_MERGE": 60,
              "LENDING_CASH_ADVANCE": 61,
              "SECURITIES_TRADE_ERROR_CORRECTION": 62,
              "ADMIN_BALANCE_ADJUSTMENT": 63,
              "APPLE_PAY_NOT_PRESENT_PURCHASE": 64,
              "ANDROID_PAY_NOT_PRESENT_PURCHASE": 65,
              "BITCOIN_P2P": 66,
              "MONEY_ORDER": 67,
              "PAPER_MONEY_DEPOSIT": 68,
              "PWC_PURCHASE": 69,
              "INSTANT_PAY_ADVANCE": 70,
              "INSTANT_PAY_PAYBACK": 71,
              "SPONSORED_CARD_ACTIVATION": 72,
              "WIRE": 73,
              "LIGHTNING_TRANSFER": 74,
              "LENDING_DRAWDOWN": 75,
              "LENDING_PAYMENT": 76,
              "LENDING_REFUND": 77,
              "LENDING_LATE_FEE": 78,
              "LENDING_INTEREST": 79,
              "LENDING_ADJUSTMENT": 80,
              "CRYPTO_PAYROLL_CONVERSION": 81,
              "CRYPTO_CASH_CARD_ROUND_UP": 82,
              "REMITTANCE_P2P_PAYMENT": 83,
              "SAVINGS_TRANSFER": 84,
              "OVERDRAFT_LIMIT_UPDATE": 85,
              "OVERDRAFT_REPAYMENT": 86,
              "OVERDRAFT_NON_REPAYMENT_UPDATE": 87,
              "SQUARE_TAP_TO_PAY": 88,
              "OVERDRAFT_RECOUP_REPAYMENT": 89,
              "OVERDRAFT_MANUAL_REPAYMENT": 90,
              "SAVINGS_INTEREST": 91,
              "BITCOIN_WITHDRAWAL": 92,
              "ONE_TIME_HOLD_TAX_LEVY": 93,
              "CONTINUOUS_HOLD_TAX_LEVY": 94,
              "CRYPTO_PURCHASE": 95,
              "EQUITY_PURCHASE": 96,
              "REMITTANCE": 97,
              "RECEIVERSHIP": 98,
              "INFORMATION_SUBPOENA": 99,
              "USDC_BUY": 100,
              "USDC_SELL": 101,
              "MONEY_POOL_PAYMENT": 102,
              "MONEY_POOL_TRANSFER": 103,
              "SQUARE_TIP_PAYMENT": 104
            }
          },
          "TransactionDeclineReason": {
            "values": {
              "UNKNOWN": 1,
              "INSUFFICIENT_BALANCE": 2,
              "POTENTIALLY_INSUFFICIENT_BALANCE": 3,
              "BLOCKED_BY_RISK": 4,
              "CARD_DISABLED": 5,
              "INVALID_CURRENCY": 6,
              "RISK_SYSTEMS_UNAVAILABLE": 7
            }
          },
          "TransactionEvent": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "transactionToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.banklin.TransactionState",
                "id": 3,
                "rule": "optional"
              },
              "externalSystem": {
                "type": ".squareup.banklin.external.ExternalSystem",
                "id": 4,
                "rule": "optional"
              },
              "externalSystemId": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "balanceToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "instrumentToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "occurredAt": {
                "type": "int64",
                "id": 8,
                "rule": "optional"
              },
              "eventOrder": {
                "type": "int64",
                "id": 16,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "balanceSnapshotAmount": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "description": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "reference": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "declineReason": {
                "type": ".squareup.banklin.TransactionDeclineReason",
                "id": 13,
                "rule": "optional"
              },
              "balanceSnapshotVersion": {
                "type": "int64",
                "id": 14,
                "rule": "optional"
              },
              "octopusResult": {
                "type": ".squareup.banklin.octopus.OctopusResult",
                "id": 15,
                "rule": "optional"
              },
              "reasonCode": {
                "type": ".squareup.banklin.TransactionReasonCode",
                "id": 18,
                "rule": "optional"
              },
              "kind": {
                "type": ".squareup.banklin.EventKind",
                "id": 19,
                "rule": "optional"
              },
              "amountType": {
                "type": ".squareup.banklin.AmountType",
                "id": 31,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 20,
                "rule": "optional"
              },
              "expiresAt": {
                "type": "int64",
                "id": 21,
                "rule": "optional"
              },
              "customerToken": {
                "type": "string",
                "id": 23,
                "rule": "optional"
              },
              "precedingRelatedExternalSystemId": {
                "type": "string",
                "id": 25,
                "rule": "optional"
              },
              "disputeFundsAvailability": {
                "type": ".squareup.banklin.DisputeFundsAvailability",
                "id": 26,
                "rule": "optional"
              },
              "customerFeeSatoshis": {
                "type": "uint64",
                "id": 27,
                "rule": "optional"
              },
              "targetWalletAddress": {
                "type": "string",
                "id": 28,
                "rule": "optional"
              },
              "balanceType": {
                "type": ".squareup.banklin.StoredValueBalance.Type",
                "id": 29,
                "rule": "optional"
              },
              "internationalFee": {
                "type": ".squareup.common.Money",
                "id": 30,
                "rule": "optional"
              },
              "discount": {
                "type": ".squareup.banklin.TransactionEvent.Discount",
                "id": 22
              }
            },
            "nested": {
              "Discount": {
                "fields": {
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "discountAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "rewardDiscount": {
                    "type": ".squareup.banklin.RewardDiscount",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reward": {
                    "type": ".squareup.banklin.rewards.Reward",
                    "id": 1
                  }
                },
                "nested": {
                  "source": {
                    "oneof": [
                      "reward"
                    ]
                  }
                }
              },
              "kind_specific_details": {
                "oneof": [
                  "discount"
                ]
              }
            }
          },
          "DisputeFundsAvailability": {
            "values": {
              "RELEASE_TO_CUSTOMER": 1,
              "WITHHOLD": 2,
              "ISSUED": 3,
              "NOT_ISSUED": 4
            }
          },
          "AmountType": {
            "values": {
              "AMOUNT_TYPE_UNSPECIFIED": 0,
              "AMOUNT_TYPE_PRINCIPAL": 1,
              "AMOUNT_TYPE_ACQUIRER_FEE": 2,
              "AMOUNT_TYPE_DISCOUNT": 3,
              "AMOUNT_TYPE_CASH_APP_FEE": 4,
              "AMOUNT_TYPE_CASH_BACK": 5,
              "AMOUNT_TYPE_ACQUIRER_FEE_REIMBURSEMENT": 6,
              "AMOUNT_TYPE_CASH_APP_FEE_REIMBURSEMENT": 7,
              "AMOUNT_TYPE_GOVERNMENT_FEE": 8,
              "AMOUNT_TYPE_TAX_WITHHOLDING": 9,
              "AMOUNT_TYPE_LOAN_PRINCIPAL": 10,
              "AMOUNT_TYPE_LOAN_INTEREST": 11,
              "AMOUNT_TYPE_LOAN_SETUP_FEE": 12,
              "AMOUNT_TYPE_LOAN_LATE_FEE": 13,
              "AMOUNT_TYPE_CREDIT_CARD_FEE": 14,
              "AMOUNT_TYPE_BUSINESS_FEE": 15,
              "AMOUNT_TYPE_INSTANT_DEPOSIT_FEE": 16,
              "AMOUNT_TYPE_INTERNATIONAL_FEE": 17,
              "AMOUNT_TYPE_INTERNATIONAL_FEE_REIMBURSEMENT": 18,
              "AMOUNT_TYPE_OUT_OF_NETWORK_FEE": 19
            }
          },
          "EventKind": {
            "values": {
              "NO_AUTHORIZATION": 1,
              "AUTHORIZATION": 2,
              "PREAUTHORIZATION": 3,
              "AFD_PREAUTHORIZATION": 4,
              "AUTH_ADJUSTMENT": 5,
              "ACQUIRER_FEE": 6,
              "DISCOUNT": 7,
              "SUBMITTED_TO_BITBANK": 8,
              "SENT_TO_BLOCKCHAIN": 9,
              "AUTH_OVERRIDE": 10,
              "AUTH_INCREMENTAL": 11,
              "MERCHANT_REVERSAL": 12,
              "ISSUER_REVERSAL": 13,
              "BOOKKEEPING": 14,
              "CASH_APP_FEE": 15,
              "PARTIAL_CAPTURE": 16,
              "CASH_BACK": 17,
              "RECEIVED_FROM_BLOCKCHAIN": 18,
              "CASH_APP_FEE_REIMBURSEMENT": 19,
              "ACQUIRER_FEE_REIMBURSEMENT": 20,
              "SETTLED_INTERNALLY": 21,
              "EARLY_DIRECT_DEPOSIT": 22,
              "PROVISIONAL_CREDIT_ISSUED": 23,
              "PROVISIONAL_CREDIT_WITHHELD": 24,
              "PARTIAL_AUTH": 25,
              "PAPER_CASH_DEPOSIT": 26,
              "GOVERNMENT_FEE": 27,
              "TAX_WITHHOLDING": 28,
              "LOAN_PRINCIPAL": 29,
              "LOAN_INTEREST": 30,
              "LOAN_SETUP_FEE": 31,
              "LOAN_LATE_FEE": 32,
              "INTERNAL_REVERSAL": 33,
              "RULE_BASED_AUTO_INTERNAL_REVERSAL": 34,
              "AGENT_INTERNAL_REVERSAL": 35,
              "INTERNATIONAL_FEE": 36,
              "INTERNATIONAL_FEE_REIMBURSEMENT": 37,
              "CREDIT_CARD_FEE": 38,
              "INSTANT_DEPOSIT_FEE": 39,
              "BUSINESS_FEE": 40,
              "OUT_OF_NETWORK_FEE": 41
            }
          },
          "RewardDiscount": {
            "fields": {
              "discountToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "missingRewardReportToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "missingRewardReportData": {
                "type": ".squareup.banklin.RewardDiscount.MissingRewardReportData",
                "id": 8,
                "rule": "optional"
              },
              "crossCurrencyReward": {
                "type": ".squareup.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "crossCurrencyRewardExchangeRate": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "cardTransactionToken": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "rewardTransactionToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "crossCurrencyRewardInfo": {
                "type": ".squareup.banklin.RewardDiscount.CrossCurrencyRewardInfo",
                "id": 13,
                "rule": "optional"
              },
              "rewardAmount": {
                "type": ".squareup.common.Money",
                "id": 5
              },
              "rewardBasisPoints": {
                "type": "int64",
                "id": 6
              }
            },
            "nested": {
              "MissingRewardReportData": {
                "fields": {
                  "missingRewardReportToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "approvedOnce": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "approvalReason": {
                    "type": ".squareup.banklin.RewardDiscount.MissingRewardReportData.ApprovalReason",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ApprovalReason": {
                    "values": {
                      "MERCHANT_DATA_UPDATED": 1,
                      "ONE_TIME_APPROVAL_SILENT": 2,
                      "ONE_TIME_APPROVAL": 3
                    }
                  }
                }
              },
              "CrossCurrencyRewardInfo": {
                "fields": {
                  "rewardAmount": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rewardCurrency": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rewardValueSnapshot": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "rewardExchangeRate": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "rewardTransactionToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardTransactionToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "discount": {
                "oneof": [
                  "rewardAmount",
                  "rewardBasisPoints"
                ]
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.TransactionState && !$root.nested?.squareup?.nested?.banklin?.nested?.TransactionReasonCode && !$root.nested?.squareup?.nested?.banklin?.nested?.TransactionDeclineReason && !$root.nested?.squareup?.nested?.banklin?.nested?.TransactionEvent && !$root.nested?.squareup?.nested?.banklin?.nested?.TransactionEvent?.nested?.Discount && !$root.nested?.squareup?.nested?.banklin?.nested?.DisputeFundsAvailability && !$root.nested?.squareup?.nested?.banklin?.nested?.AmountType && !$root.nested?.squareup?.nested?.banklin?.nested?.EventKind && !$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount && !$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.MissingRewardReportData && !$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.MissingRewardReportData?.nested?.ApprovalReason && !$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.CrossCurrencyRewardInfo) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE TransactionState @ squareup/banklin/transaction.proto at 87:1
 */
export const TransactionState = $root.lookupEnum('squareup.banklin.TransactionState').values;
/**
 * This enum describes what kind of transaction this is. It is intended to
 * capture the originating reason for this transaction.
 *
 * SOURCE TransactionReasonCode @ squareup/banklin/transaction.proto at 175:1
 */
export const TransactionReasonCode = $root.lookupEnum('squareup.banklin.TransactionReasonCode').values;
/**
 * SOURCE TransactionDeclineReason @ squareup/banklin/transaction.proto at 524:1
 */
export const TransactionDeclineReason = $root.lookupEnum('squareup.banklin.TransactionDeclineReason').values;
/**
 * SOURCE TransactionEvent @ squareup/banklin/transaction.proto at 559:1
 */
export const TransactionEvent = $root.lookupType('squareup.banklin.TransactionEvent');
fixType(TransactionEvent);
Builder.createAndAttachToType(TransactionEvent);
/**
 * SOURCE Discount @ squareup/banklin/transaction.proto at 631:3
 */
TransactionEvent.Discount = $root.lookupType('squareup.banklin.TransactionEvent.Discount');
fixType(TransactionEvent.Discount);
Builder.createAndAttachToType(TransactionEvent.Discount);
/**
 * When we get a dispute transaction advice we want to react differently to them depending on if
 * the merchant/acquirer challenges the dispute and we're instructed not to issue credits etc.
 *
 * SOURCE DisputeFundsAvailability @ squareup/banklin/transaction.proto at 682:1
 */
export const DisputeFundsAvailability = $root.lookupEnum('squareup.banklin.DisputeFundsAvailability').values;
/**
 * Type of the amount, for distinguishing between different types of fees and discounts.
 * Historically this used to be communicated by EventKind enum, but we needed a new concept to be
 * able to distinguish amount types for pending transactions.
 *
 * Next ID: 19
 *
 * SOURCE AmountType @ squareup/banklin/transaction.proto at 712:1
 */
export const AmountType = $root.lookupEnum('squareup.banklin.AmountType').values;
/**
 * The event kind, currently only for pending events but extensible.
 * This field is specific to an individual event.
 *
 * SOURCE EventKind @ squareup/banklin/transaction.proto at 777:1
 */
export const EventKind = $root.lookupEnum('squareup.banklin.EventKind').values;
/**
 * SOURCE RewardDiscount @ squareup/banklin/transaction.proto at 957:1
 */
export const RewardDiscount = $root.lookupType('squareup.banklin.RewardDiscount');
fixType(RewardDiscount);
Builder.createAndAttachToType(RewardDiscount);
/**
 * SOURCE MissingRewardReportData @ squareup/banklin/transaction.proto at 969:3
 */
RewardDiscount.MissingRewardReportData = $root.lookupType('squareup.banklin.RewardDiscount.MissingRewardReportData');
fixType(RewardDiscount.MissingRewardReportData);
Builder.createAndAttachToType(RewardDiscount.MissingRewardReportData);
/**
 * SOURCE ApprovalReason @ squareup/banklin/transaction.proto at 972:5
 */
RewardDiscount.MissingRewardReportData.ApprovalReason = $root.lookupEnum('squareup.banklin.RewardDiscount.MissingRewardReportData.ApprovalReason').values;
/**
 * Populated only if this payment is a boost where the reward is a different currency than the
 * card transaction.  Gives us context related to the reward transaction for display on the card
 * transaction.
 *
 * SOURCE CrossCurrencyRewardInfo @ squareup/banklin/transaction.proto at 996:3
 */
RewardDiscount.CrossCurrencyRewardInfo = $root.lookupType('squareup.banklin.RewardDiscount.CrossCurrencyRewardInfo');
fixType(RewardDiscount.CrossCurrencyRewardInfo);
Builder.createAndAttachToType(RewardDiscount.CrossCurrencyRewardInfo);
